import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=6ae0ece4&scoped=true"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"
import style0 from "./CollapseTransition.vue?vue&type=style&index=0&id=6ae0ece4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae0ece4",
  null
  
)

export default component.exports